<template>
    <div class="image-uploader">
      <el-upload
        class="upload-demo"
        action="https://www.xmyr.top/api/bed/uploadFoodImg"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :limit="limit"
        :on-exceed="handleExceed"
        :file-list="fileList"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="Preview Image">
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ImageUploader',
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        limit:1,
        uploadedImageUrls: [],
      };
    },
    methods: {
      handleRemove(file, fileList) {
        console.log('File removed:', file);
        // 从uploadedImageUrls数组中移除被删除的图片URL
        this.uploadedImageUrls = this.uploadedImageUrls.filter(url => url !== file.url);
        this.fileList = fileList; // 更新fileList
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
        console.log('Upload success:', response);
        // 假设服务器返回的响应包含图片的URL
        const imageUrl = response.data;
        this.fileList = fileList;
        // 更新fileList中的URL
        fileList.forEach(item => {
          if (!item.url && item.response) {
            item.url = item.response.url;
          }
        });
        // 将新的图片路径添加到uploadedImageUrls数组中
        this.uploadedImageUrls.push(imageUrl);
        this.$emit('update:fileList', this.uploadedImageUrls); // 通知父组件更新
      },
      handleExceed(files, fileList) {
        this.$message.warning("只能上传"+this.limit+"张图片!");
      }
    }
  };
  </script>
  
  <style scoped>
  
  </style>
  